import Backbone from 'backbone'
import _ from 'lodash'
import context from './initiatives-context'
import template from './initiatives-overview-info.hbs'
import basicInfo from 'scoreboard/components/overview-info/basic-info.hbs'
import RelatedItemsList from 'scoreboard/related-items/related-items-list'
import AllTags from 'scoreboard/components/all-tags'

var InitiativesOverviewInfo = Backbone.View.extend({

	className: 'overview-info',

	events: {
		'click .tags-panel .badge': 'displayTags'
	},

	render: function() {
		var ctx = context(this.model, {replaceWithUnshortened: true})
		this.$el.empty().append(template(ctx))
		this.$('.basic-info').replaceWith(basicInfo(ctx))

		this.relatedItemsList = new RelatedItemsList({ model: this.model })
		this.$('.related').html(this.relatedItemsList.el)
		this.relatedItemsList.render()

		return this
	},

	displayTags: AllTags.display,

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.relatedItemsList], 'remove')
	}

})

export default InitiativesOverviewInfo

InitiativesOverviewInfo.__filename__ = 'initiatives/overview/initiatives-overview-info.js'
